import { Option } from '@repo/toolkit/types'

export const yearsFilterOptions: Option<number>[] = (() => {
  // Start from 2024 and include up to currentYear + 20.
  // This prevents any years before 2024 from appearing.
  const startYear = 2024
  const currentYear = new Date().getFullYear()
  const endYear = currentYear + 20

  return Array.from({ length: endYear - startYear + 1 }, (_, i) => {
    const year = startYear + i
    return { label: year.toString(), value: year }
  })
})()

export const childAges: Option<number>[] = Array.from({ length: 11 }, (_, i) => {
  const age = i + 8
  const label = age === 18 ? '18 et +' : `${age} ans`
  return { label, value: age }
})

export const capitalize = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
